import { mapActions } from 'vuex'
import { judgeClientSystem, getKey, isWxMiniprogram, copyToClipbord, isBaiduMiniprogram } from '@/assets/utils'
export default {
  data () {
    return {
      jumpPosition: '',
      packageId: '',
      packageKey: '',
      appUrl: ['H5-ppd', 'H5-ppd1', 'H5-ppd2'].includes(this.$route.query.channel) ? 'https://itunes.apple.com/cn/app/id' : 'itms-appss://apps.apple.com/cn/app/id'
    }
  },
  computed: {
    IsIosDownload () {
      return this.jumpPosition === 'APP_PACKAGE'
    }
  },
  methods: {
    ...mapActions('user', ['getChannelJumpX']),
    async getAppInfo () {
      if (judgeClientSystem() === 'IOS') {
        const { success, data } = await this.getChannelJumpX()
        if (success) {
          const { jumpPosition, packageId, packageKey } = data
          if (jumpPosition === 'APP_PACKAGE') {
            this.jumpPosition = jumpPosition
            this.packageId = packageId
            this.packageKey = packageKey
            this.appUrl += packageId
          }
        }
      }
    },
    generalDownloadAction () {
      if (isWxMiniprogram() || isBaiduMiniprogram()) {
        // 是微信小程序 || 百度小程序
        const userInfo = getKey('userInfo') || {}
        if (window.location.search) {
          copyToClipbord(`${window.location.href}&token=${userInfo.token}`)
        } else {
          copyToClipbord(`${window.location.href}?token=${userInfo.token}`)
        }
        this.$message('复制成功', 2000)
      } else if (this.$route.query.channel === 'H5-wbsk' || getKey('channel') === 'H5-wbsk') {
        this.copyUrlAndToast()
      } else {
        if (this.isIos) {
          if (this.IsIosDownload) {
            window.location.href = this.appUrl
            return
          }
          if (this.home === 'T') {
            return this.$router.replace('/')
          }
          this.$nextTick(() => {
            this.downloadVisible = true
          })
          this.callAppBySchema('tianmeiqianbao://').then((res) => {
            if (!res) {
              if (
                document.webkitHidden ||
                document.hidden ||
                document.msHidden ||
                document.mozHidden
              ) {
                // 隐藏
                return false
              }
            }
          })
        } else {
          this.downloadApp()
        }
      }
    }
  }
}